import { render } from "./NetworkIssue.vue?vue&type=template&id=17234e12"
const script = {}
script.render = render

export default script